export const authConstants = {
    LOGOUT_401: "LOGOUT_401",
    NOT_LOGGED_IN_REDIRECT: "NOT_LOGGED_IN_REDIRECT",
    NOT_LOGGED_IN_REDIRECT_REMOVE: "NOT_LOGGED_IN_REDIRECT_REMOVE",

    // Token storage constants
    SAVE_AUTH_TOKEN: "SAVE_AUTH_TOKEN",
    REMOVE_AUTH_TOKEN: "REMOVE_AUTH_TOKEN",
    SWITCH_ACCOUNT: "SWITCH_ACCOUNT",
    UPDATE_LAST_CONNECTED: "UPDATE_LAST_CONNECTED",
    RESET_AUTH_STATE: "RESET_AUTH_STATE",
    ACCEPT_LOGIN_LINK: "ACCEPT_LOGIN_LINK",
}
